module.exports = __webpack_public_path__ + "media/building-lobby-ambience.ea69ed40.mp3";